import type {
  Flow_AbstractComponent,
  Flow_Diff,
  Flow_ComponentProps,
  Flow_ObjMap,
} from 'src/types/flow-to-typescript-codemod';
import * as React from 'react';

import classify from 'src/utils/classify';

import css from './hover-icon-button.css';


type ButtonProps = Readonly<{
  className: string;
  onClick?: () => unknown;
  style?:
    | {
        [key: string]: string | number;
      }
    | null
    | undefined;
}>;

type Props = {
  ElementType?: Flow_AbstractComponent<ButtonProps, HTMLElement> | string;
  children: React.ReactNode;
  width?: number;
  height?: number;
  padding?: number;
  onClick?: (arg1: React.SyntheticEvent) => unknown;
  bgIconClassName?: string;
  className?: string;
  active?: boolean;
  hoverDisabled?: boolean;
  dimensions?: 'full' | 'icon';
  // @ts-expect-error - TS1337 - An index signature parameter type cannot be a literal type or generic type. Consider using a mapped object type instead.
  [key: 'aria-label']: string;
};

// NOTE (kyle): this component allows changing the underlying element so
// HTMLElement will not always hold true if you're using a custom component.
// Declaring an ElementType and sending properties it will fail a Flow check.
// To fix this, we'll need to create a component factory with a generic
// ElementType.
// @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<HTMLElement & RefAttributes<Props>>' is not assignable to type 'AbstractComponent<Props, HTMLElement>'.
export const HoverIconButton: Flow_AbstractComponent<Props, HTMLElement> =
  React.forwardRef<Props, HTMLElement>((props, ref) => {
    const {
      // @ts-expect-error - TS2339 - Property 'ElementType' does not exist on type 'HTMLElement'.
      ElementType = 'button',
      children,
      // @ts-expect-error - TS2339 - Property 'onClick' does not exist on type 'HTMLElement'.
      onClick,
      // @ts-expect-error - TS2339 - Property 'width' does not exist on type 'HTMLElement'.
      width = 24,
      // @ts-expect-error - TS2339 - Property 'height' does not exist on type 'HTMLElement'.
      height = 24,
      // @ts-expect-error - TS2339 - Property 'padding' does not exist on type 'HTMLElement'.
      padding = 0,
      className,
      // @ts-expect-error - TS2339 - Property 'bgIconClassName' does not exist on type 'HTMLElement'.
      bgIconClassName,
      // @ts-expect-error - TS2339 - Property 'hoverDisabled' does not exist on type 'HTMLElement'.
      hoverDisabled = false,
      // @ts-expect-error - TS2339 - Property 'active' does not exist on type 'HTMLElement'.
      active = false,
      // @ts-expect-error - TS2339 - Property 'dimensions' does not exist on type 'HTMLElement'.
      dimensions = 'icon',
      ...rest
    } = props;
    const minDiameter = Math.max(width, height);

    return (
      <ElementType
        {...rest}
        ref={ref}
        type="button"
        role="button"
        className={classify(css.hoverIcon, className)}
        onClick={onClick}
        style={
          dimensions === 'full'
            ? {
                width: minDiameter,
                height: minDiameter,
              }
            : null
        }
      >
        <div className={css.hoverIconRoot}>
          <div className={css.hoverIconBgContainer}>
            <div
              className={classify(
                css.bgIconClassName,
                {
                  [css.hoverIconBg]: !hoverDisabled,
                  [css.hoverIconBgActive]: active,
                },
                bgIconClassName,
              )}
              style={{
                width: minDiameter,
                height: minDiameter,
                borderRadius: minDiameter,
              }}
            />
          </div>
          {/* @ts-expect-error - TS2322 - Type 'HTMLCollection' is not assignable to type 'ReactNode'. */}
          <div className={css.hoverIconIcon}>{children}</div>
        </div>
      </ElementType>
    );
  });
